var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Winery"},[_vm._l((_vm.imglist),function(item,index){return (_vm.imglist.length)?_c('VanImage',{key:index,attrs:{"width":"100%","height":"100%","lazy-load":"","fit":"cover","src":item}}):_vm._e()}),(!_vm.imglist.length)?_c('Empty',{attrs:{"description":"暂无数据"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }